<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #code="{ row }">
        <div>
          {{ getNameByValue(deviceCode, row.device_code) }}
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openEdit(row)"
            >修改</el-button
          >
           <el-button type="success" v-if="row.device_code == 'ASI'" size="small" @click="openAddUser(row)"
            >添加用户</el-button
          >
            <el-button type="primary" v-if="row.device_code == 'ASI'" size="small" @click="userList(row)"
            >用户列表</el-button
          >
           <el-button type="success" v-if="row.device_code == 'ASI'" size="small" @click="openDoorList(row)"
            >开门记录</el-button
          >
          <el-popconfirm
          v-if="row.device_code == 'ASI'"
            @confirm="openDoor(row)"
            title="确认要远程开门吗"
          >
            <el-button slot="reference" type="warning" size="small">远程开门</el-button>
          </el-popconfirm>
           <el-popconfirm
            @confirm="delDevice(row)"
            title="确认要删除设备吗"
          >
            <el-button slot="reference" type="danger" size="small">删除设备</el-button>
          </el-popconfirm>
        </div>
      </template>
    </auto-table>

    <AddorEdit ref="add" @success="getList(1)"></AddorEdit>
    <addUser ref="addUser"></addUser>
    <userList ref="userList"></userList>
    <openRecordList ref="openRecordList"></openRecordList>
  </div>
</template>

<script>

import AddorEdit from "./addDevice.vue";
import { deviceCode } from "@/views/deviceManage/components/dict";
import addUser from './addUser.vue';
import userList from './userList.vue';
import openRecordList from './openRecordList.vue';

export default {
  props:{
    mec:{
      type:Object,
      default:()=>{return {}}
    }
  },
  components: {
    AddorEdit,
    addUser,
    userList,
    openRecordList
  },
  data() {
    return {
      deviceCode,
      DataList: [],
      Option: [
        { name: "名称", value: "device_name" },
        { name: "序列号", value: "device_id"},
        { name: "级别", value: "code",type:"custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      mechanism_id:''
    };
  },

mounted() {
    this.mechanism_id = this.$route.query.mecID;
},
  methods: {
    init() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    userList(row){
      this.$refs.userList.open(row)
    },
    openDoorList(row){
      this.$refs.openRecordList.open(row)
    },
    openAddUser(row){
        this.$refs.addUser.open(row)
    },

    openAdd() {
      let comm = { 
          longitude: this.mec.longitude,
          latitude: this.mec.latitude
       };
      this.$refs.add.open(comm);
    },
    openEdit(row) {
      this.$refs.add.open(row);
    },
    openDoor(row){
        let param={
            device_id:row.device_id
        }
        this.$post('device/device/openDoor',param).then(res=>{
          this.$message('开门成功')
        })
    },
    delDevice(row){
        let param={
            device_id:row.device_id
        }
        this.$post('device/device/delete',param).then(res=>{
          this.$message('删除成功')
           this.getList(1);
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/device/device/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          mechanism_id: this.mechanism_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>